import { combineReducers } from "redux";
import wallethistory from "../features/admin/wallet/wallethistory/Slice";




const wallet = combineReducers({
   wallethistory: wallethistory,
  
  });
  
  export default wallet;